import React, { useEffect, useState } from "react";
import {
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  Button,
} from "react-bootstrap";
import Logo from "../../assets/images/logo.svg";
import LogoSidebar from "../../assets/images/logo.svg";
import en from "../../assets/icons/united-states.svg";
import it from "../../assets/icons/italy.svg";
import fr from "../../assets/icons/france.svg";
import de from "../../assets/icons/germany.svg";
import es from "../../assets/icons/spain.svg";
import Menu from "../../assets/icons/menu.svg";
import Hamburger from "../../assets/icons/Hamburger.svg";
import { useTranslation } from "react-i18next";
import { lang, toggleLanguage } from "../../i18n";
import "./index.css";
import { Link } from "react-router-dom";

const PARTNER_CODE = process.env.REACT_APP_PARTNER_CODE || "";

const languages = [
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];
const Index = () => {
  const { t } = useTranslation();
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleChangeLanguage = (value) => {
    const selectedLang = value;
    if (selectedLang !== lang()) {
      toggleLanguage(selectedLang); // Update the language in i18n
      document.documentElement.lang = selectedLang; // Update the HTML lang attribute

      // Get the current path and split it into segments
      const pathSegments = window.location.pathname.split("/");
      const currentLang = pathSegments[1]; // Extract the current language from the URL

      // Check if the current segment is a supported language
      const isLangInPath = languages.some((lang) => lang.code === currentLang);

      // Construct the new URL
      let newPath;
      if (isLangInPath) {
        // Replace the current language in the URL with the new one
        pathSegments[1] = selectedLang;
        newPath = pathSegments.join("/");
      } else {
        // Insert the new language at the beginning of the path
        newPath = `/${selectedLang}${window.location.pathname}`;
      }

      // Redirect to the new URL
      window.location.href = newPath;
    }
  };

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);
  const closeSidebar = () => setIsSidebarVisible(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      // Adjust this value as needed
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <header className={isScrolled ? "scrolled" : ""}>
      <Navbar expand="lg" className="bg-gray p-0">
        <Container>
          <div className="navbar_wrapper w-100 d-flex justify-content-between align-items-center">
            <Navbar.Brand href="/" className="p-0 m-0">
              <img src={Logo} alt="Logo" className="img-fluid logo" />
            </Navbar.Brand>
            <div className="d-lg-flex d-none align-items-center">
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={toggleSidebar}
              />
              <Navbar.Collapse
                id="basic-navbar-nav"
                className={isSidebarVisible ? "d-block" : "d-none"}
              >
                <Nav className="me-auto">
                  <ul>
                    <li>
                      <Nav.Link href="#home_banner_section" className="active">
                        {t("home")}
                      </Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="#how_it_work_sec">
                        {t("how_it_works")}
                      </Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="#contact_form">
                        {t("contact_us")}
                      </Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="#about_us_sec">{t("About Us")}</Nav.Link>
                    </li>
                  </ul>
                </Nav>
                <Button
                  variant="link"
                  className="close_sidebar_btn"
                  onClick={closeSidebar}
                >
                  ×
                </Button>
              </Navbar.Collapse>
            </div>
            <div className="lang_button_wrapper">
              <div className="book_button">
                <Nav.Link
                  href={`https://app.quotabus.com/${PARTNER_CODE}`}
                  target="_blank"
                >
                  {t("get_quote")}
                </Nav.Link>
              </div>
              <Form.Group
                controlId="countryLanguageSelect"
                className="country_dropdown"
              >
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <img
                      src={
                        lang() === "it"
                          ? it
                          : lang() === "en"
                          ? en
                          : lang() === "fr"
                          ? fr
                          : lang() === "de"
                          ? de
                          : lang() === "es"
                          ? es
                          : null
                      }
                      alt={`Flag representing ${lang().toUpperCase()} language`}
                      width="20"
                      height="15"
                      className="me-2"
                    />
                    {lang().toLocaleUpperCase()}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {languages.map(({ code, name, flag }) => (
                      <Dropdown.Item
                        key={code}
                        onClick={() => handleChangeLanguage(code)}
                      >
                        {flag} {name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>
              <Button
                variant="link"
                className="custom_sidebar_toggle d-lg-none"
                onClick={toggleSidebar}
              >
                <img src={Menu} alt="Menu" />
              </Button>
            </div>
          </div>
        </Container>
      </Navbar>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarVisible ? "show" : ""}`}>
        <div className="sidebar_content">
          <div className="logo_wrapper">
            <a href="/">
              <img src={LogoSidebar} alt="Logo" className="img-fluid" />
            </a>
            <Button
              variant="link"
              className="close_sidebar_btn"
              onClick={closeSidebar}
            >
              {" "}
              <img src={Hamburger} alt="Hamburger" />
            </Button>
          </div>
          <Nav className="flex-column link_list">
            <Nav.Link href="#home_banner_section" onClick={closeSidebar}>
              {t("home")}
            </Nav.Link>
            <Nav.Link href="#how_it_work_sec" onClick={closeSidebar}>
              {t("how_it_works")}
            </Nav.Link>
            <Nav.Link href="#contact_form" onClick={closeSidebar}>
              {t("contact_us")}
            </Nav.Link>
          </Nav>
          <Link
            to={`https://app.quotabus.com/${PARTNER_CODE}`}
            target="_blank"
            className="menubutton"
          >
            {t("get_quote")}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Index;
